import { create } from "zustand";
import { applyTelegramChrome } from "../lib/tg";

type Theme = "light" | "dark";

const STORAGE_KEY = "sv-theme";

function getInitial(): Theme {
  try {
    const saved = localStorage.getItem(STORAGE_KEY) as Theme | null;
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    /* приватный режим — падать из-за темы не станем */
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

interface ThemeStore {
  theme: Theme;
  toggleTheme: () => void;
}

// Тема живёт в общем сторе, а не в useState внутри хука: её переключают из
// профиля, а знать о смене должны все — в том числе слой, который красит хром
// Telegram. С локальным состоянием у каждого вызова хука была своя копия, и
// подписчик просто не узнавал о переключении.
const useThemeStore = create<ThemeStore>((set) => ({
  theme: getInitial(),
  toggleTheme: () => set((s) => ({ theme: s.theme === "dark" ? "light" : "dark" })),
}));

function apply(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* приватный режим — тема просто не переживёт перезапуск */
  }
  // Шапка и фон клиента красятся нашей палитрой — иначе тёмная тема
  // приложения соседствует со светлой шапкой Telegram.
  applyTelegramChrome();
}

apply(useThemeStore.getState().theme);
useThemeStore.subscribe((s) => apply(s.theme));

export function useTheme() {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  return { theme, toggleTheme };
}
